import axios from 'axios'
import Cookie from 'js-cookie'

const BASE_URL = 'https://rc.rc-cloudlink.com'
// const BASE_URL = 'https://caixiao.lianglianyn.com'
// https://mini.91comcrm.com

// 自定义 API 错误类，包含 code 和 data
class ApiError extends Error {
  constructor (code, message, data = null) {
    super(message)
    this.code = code
    this.data = data
    this.name = 'ApiError'
  }
}

class Request {
  constructor () {
    this.instance = axios.create({
      baseURL: BASE_URL,
      timeout: 30000,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    // 请求拦截器：自动添加 token，并将 userId/workId 注入到请求中
    this.instance.interceptors.request.use(
      (config) => {
        const token = Cookie.get('token')
        if (token) {
          config.headers.comlistToken = token
        }

        // 从 localStorage 读取用户信息（使用驼峰变量名）
        const workId = localStorage.getItem('work_id')
        const userId = localStorage.getItem('user_id')
        const userType = localStorage.getItem('user_type')

        // 注入到请求中：
        // - 对于 GET 请求，附加到 params（查询字符串）
        // - 对于 POST/PUT/DELETE 等，附加到 data（请求体）
        const method = config.method ? config.method.toLowerCase() : 'get'
        if (method === 'get') {
          // GET 请求使用 params
          config.params = config.params || {}
          if (userId) config.params.user_id = userId // 后端字段名保持下划线
          if (workId) config.params.work_id = workId
        } else {
          // 非 GET 请求使用 data
          config.data = config.data || {}
          if (userId) config.data.user_id = userId
          if (workId) config.data.work_id = workId
          if (userType) config.data.user_type = userType
        }

        console.log('请求参数:', config.data || config.params)
        console.log('请求URL:', config.baseURL + config.url)
        return config
      },
      (error) => Promise.reject(error) // 此处 error 本身就是 Error 实例，无需修改
    )

    // 响应拦截器：统一处理业务状态码
    this.instance.interceptors.response.use(
      (response) => {
        const data = response.data
        console.log('响应数据:', data)

        // 业务成功或特殊状态码（4、5）均 resolve
        if (data.code === 0 || data.code === 4 || data.code === 5 || data.code === '0') {
          return data
        } else {
          // 业务逻辑错误 → 抛出 ApiError
          throw new ApiError(
            data.code || -1,
            data.message || data.msg || '业务逻辑错误',
            data.data || null
          )
        }
      },
      (error) => {
        // HTTP 或网络错误处理
        if (error.response) {
          const status = error.response.status
          let message = ''
          switch (status) {
            case 400: message = '请求错误'; break
            case 401: message = '未授权，请登录'; break
            case 403: message = '拒绝访问'; break
            case 404: message = `请求地址出错: ${error.response.config.url}`; break
            case 408: message = '请求超时'; break
            case 500: message = '服务器内部错误'; break
            case 501: message = '服务未实现'; break
            case 502: message = '网关错误'; break
            case 503: message = '服务不可用'; break
            case 504: message = '网关超时'; break
            case 505: message = 'HTTP版本不受支持'; break
            default: message = `连接错误${status}`
          }
          // 抛出 ApiError，包含 HTTP 状态码和响应数据
          throw new ApiError(status, message, error.response.data)
        } else if (error.request) {
          // 请求发出但未收到响应
          throw new ApiError(-1, '网络连接异常，请检查网络设置', null)
        } else {
          // 其他异常（如配置错误）
          throw new ApiError(-1, error.message || '请求异常', null)
        }
      }
    )
  }

  // 通用请求方法（兼容原接口）
  request (options) {
    // 对于 GET 请求，将 data 转为 params
    const method = (options.method || 'GET').toLowerCase()
    const config = {
      url: options.url,
      method: options.method || 'GET',
      headers: options.header || {}
    }
    if (method === 'get') {
      config.params = options.data || {}
    } else {
      config.data = options.data || {}
    }
    return this.instance.request(config)
  }

  // GET 请求
  get (url, data = {}, header = {}) {
    return this.request({
      url,
      method: 'GET',
      data,
      header
    })
  }

  // POST 请求
  post (url, data = {}, header = {}) {
    return this.request({
      url,
      method: 'POST',
      data,
      header
    })
  }
}

// 导出单例
const request = new Request()
export default request
